import UBT from 'utils/ubt';

const pageId = 'evbike_problemSolution';
const categoryId = 'evbike';
const base = { pageId, categoryId };

export default {
  pageView(businessInfo = {}) {
    try {
      UBT.pageView({
        ...base,
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  pageViewOut(businessInfo = {}) {
    return {
      ...base,
      businessInfo,
    };
  },
  problemSolutionConvClick(businessInfo = {}, problemType: string) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_conv',
        businessInfo: {
          ...businessInfo,
          problem_type: problemType,
        },
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  problemSolutionUnlockClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_unlock',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  fineAppealClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_fineAppeal',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  evbike_problemSolution_fineAppeal(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_fineAppeal',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  accidentClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_accident',
        businessInfo,
      });
    } catch (error) {
      // empty
    }
  },
  // accidentLockClick(businessInfo = {}) {
  //   try {
  //     UBT.clickButton({
  //       ...base,
  //       buttonName: 'evbike_problemSolution_accident_lock',
  //       businessInfo,
  //     });
  //   } catch (error) {
  //     // empty
  //   }
  // },
  accidentCallClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_accident_call',
        businessInfo,
      });
    } catch (error) {
      // empty
    }
  },
  moreToServiceClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_moreToService',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  tryGetReElecOKClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_tryGetReElec_OK',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  tryGetReElecUnsettledClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problemSolution_tryGetReElec_unsettled',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  tryGetReElecModuleExpose(businessInfo = {}) {
    try {
      UBT.moduleExpose({
        ...base,
        moduleId: 'evbike_problemSolution_tryGetReElec',
        contentId: 'evbike_problemSolution_tryGetReElec',
        exposureTimes: '1',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  accidentConfPopModuleExpose(businessInfo = {}) {
    try {
      UBT.moduleExpose({
        ...base,
        moduleId: 'evbike_problemSolution_accident_confPop',
        contentId: 'evbike_problemSolution_accident_confPop',
        exposureTimes: '1',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  takePhotoPageView(businessInfo = {}) {
    try {
      UBT.pageView({
        ...base,
        pageId: 'evbike_problemConv_takePhoto',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  takePhotoPageViewOut(businessInfo = {}) {
    try {
      UBT.pageViewOut({
        ...base,
        pageId: 'evbike_problemConv_takePhoto',
        businessInfo,
      });
    } catch (error) {
      UBT.sendError(error);
    }
  },
  takePhotoSubmit(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        pageId: 'evbike_problemConv_photoSubmit',
        buttonName: 'evbike_problemConv_photoSubmit_sub',
        businessInfo,
      });
    } catch (error) {
      // empty
    }
  },
  cannotReturnBikeClick(businessInfo = {}) {
    try {
      UBT.clickButton({
        ...base,
        buttonName: 'evbike_problem_cannot_returnbike',
        businessInfo,
      });
    } catch (error) {
      // empty
    }
  },
  cannotReturnBikeModuleExpose(businessInfo = {}) {
    try {
      UBT.moduleExpose({
        ...base,
        moduleId: 'evbike_problem_cannot_returnbike',
        contentId: 'evbike_problem_cannot_returnbike',
        businessInfo,
      });
    } catch (error) {
      // empty
    }
  },
};
